import moment from 'moment';

export const prepareDateForPicker = values => {
  const dateValue = values?.startDatetime;
  const isOnlyDate = values?.startDatetimeIsOnlyDate;

  if (!dateValue) return null;

  if (isOnlyDate && dateValue.includes('T')) {
    return moment(dateValue.split('T')[0]);
  }

  return moment(dateValue);
};
